import udemy from "../../assets/img/learning/udemy.webp";
import tuto from "../../assets/img/learning/tuto.webp";
import khan from "../../assets/img/learning/khan.webp";
import coursera from "../../assets/img/learning/coursera.webp";
import skillshare from "../../assets/img/learning/skillshare.webp";
import freecodecamp from "../../assets/img/learning/freecodecamp.webp";
import github from "../../assets/img/learning/github.webp";
import codecademy from "../../assets/img/learning/codecademy.webp";
import pluralslight from "../../assets/img/learning/pluralslight.webp";
import codestartup from "../../assets/img/learning/codestartup.webp";
import frontendmentor from "../../assets/img/learning/frontendmentor.webp";
import sololearn from "../../assets/img/learning/sololearn.webp";
import acloudguru from "../../assets/img/learning/acloudguru.webp";

export const DataLearning = [
  {
    title: "Udemy",
    path: "https://www.udemy.com/",
    cName: "icon",
    icon: udemy,
    description:
      "One of the best platforms to learn in video and to teach also. More than 130 000 videos about all kind of subjects.",
  },
  {
    title: "Tuto.com",
    path: "https://fr.tuto.com/",
    cName: "icon",
    icon: tuto,
    description:
      "French platform to learn and to teach, there is also an English part. Many cursus can be paid by Pôle Emploi a french organisation.",
  },
  {
    title: "Khan academy",
    path: "https://www.khanacademy.org/",
    cName: "icon",
    icon: khan,
    description:
      "For every student, every classroom. Real results. We’re a nonprofit with the mission to provide a free, world-class education for anyone, anywhere.",
  },
  {
    title: "Coursera",
    path: "https://www.coursera.org/",
    cName: "icon",
    icon: coursera,
    description:
      "Learn by earning certification from the best university in the world.",
  },
  {
    title: "Skillshare",
    path: "https://skl.sh/2FOuEuQ",
    cName: "icon",
    icon: skillshare,
    description:
      "Explore your creativity. Join Skillshare to watch, play, learn, make, and discover. The Netflix of learning.",
  },
  {
    title: "Freecodecamp",
    path: "https://www.freecodecamp.org/learn",
    cName: "icon",
    icon: freecodecamp,
    description:
      "FreeCodeCamp is a proven path to your first software developer job. More than 40,000 people have gotten developer jobs after completing this – including at big companies like Google and Microsoft. Big Thanks to them.",
  },
  {
    title: "Github",
    path: "https://try.github.io/",
    cName: "icon",
    icon: github,
    description:
      "A good ressources to learn Git by reading, doing or training.",
  },
  {
    title: "codecademy",
    path: "https://www.codecademy.com/learn",
    cName: "icon",
    icon: codecademy,
    description:
      "Codecademy is an education company. But not one in the way you might think. We’re committed to building the best learning experience inside and out, making Codecademy the best place for our team to learn, teach, and create the online learning experience of the future.",
  },
  {
    title: "Pluralslight",
    path: "https://www.pluralsight.com/",
    cName: "icon",
    icon: pluralslight,
    description:
      "At Pluralsight, we believe everyone should have the opportunity to create progress through technology and develop the skills of tomorrow. With assessments, learning paths and courses authored by industry experts, our platform helps businesses and individuals benchmark expertise across roles, speed up release cycles and build reliable, secure products.",
  },
  {
    title: "Code4Startup",
    path: "https://code4startup.com/",
    cName: "icon",
    icon: codestartup,
    description:
      "Learn to code by creating real life Startups(AirBnb, UberEats, Tinder, Fiverr, ProductHunt...)",
  },
  {
    title: "Frontend Mentor",
    path: "https://www.frontendmentor.io/",
    cName: "icon",
    icon: frontendmentor,
    description:
      "Improve your front-end coding skills by building real projects. Solve real-world HTML, CSS and JavaScript challenges whilst working to professional designs. Join 64,228 developers building projects, reviewing code, and helping each other get better.",
  },
  {
    title: "Sololearn",
    path: "https://www.sololearn.com/",
    cName: "icon",
    icon: sololearn,
    description:
      "Learn on the web and on the go.Available on all major devices and platforms. Always pick up where you left off. More simple and enjoyable than ever!",
  },
  {
    title: "A Cloud Guru",
    path: "https://acloudguru.com/",
    cName: "icon",
    icon: acloudguru,
    description:
      "The Leader in Cloud Learning. Learn by doing with A Cloud Guru. Learn faster. Move faster. Transform now with courses and real hands-on labs in AWS, Azure, Google Cloud, and beyond.",
  },
];
